import { render, staticRenderFns } from "./DocumentEditModal.vue?vue&type=template&id=6f7215a4&scoped=true&"
import script from "./DocumentEditModal.vue?vue&type=script&lang=js&"
export * from "./DocumentEditModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentEditModal.vue?vue&type=style&index=0&id=6f7215a4&lang=scss&scoped=true&"
import style1 from "./DocumentEditModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7215a4",
  null
  
)

export default component.exports